import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TestEvaluationScaleItem } from '@/types/testReport';

const ROW_CLASS =
  'grid grid-cols-3 gap-2 p-4 [&>*:nth-child(2)]:text-left [&>*:last-child]:text-right';

interface Props {
  items: TestEvaluationScaleItem[];
}

export const EvaluationScaleTable: React.FC<Props> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-hidden rounded-xl border border-divider">
      <div
        className={`text-subhead-14 border-b border-divider bg-background text-foreground ${ROW_CLASS}`}
      >
        <span>{t('diary.testReport.scaleEvaluation')}</span>
        <span>{t('diary.testReport.scalePoints')}</span>
        <span>{t('diary.testReport.scalePercentage')}</span>
      </div>

      {items.map((item, index) => (
        <div
          key={item.evaluationValue}
          className={`text-body-14 text-muted-foreground ${index % 2 ? 'bg-on-primary-surface' : 'bg-background'} ${ROW_CLASS}`}
        >
          <span>{item.evaluationValue}</span>
          <span>{item.points}</span>
          <span>{item.percent}</span>
        </div>
      ))}
    </div>
  );
};
